import './ol_with_digits.less';

import React from 'react';
import classNames from 'classnames';

export default ({ className, ...props})=>
  <ol className={classNames('with-digits', className)} {...props} />;